import React, {useState} from "react";
import Component from "./Component";
import { toast } from 'react-toastify';
import ReactPortal from "./ReactPortal";

const CLEAR_NOTIFICATION_TIMEOUT = 3000;

const PreferenceInput = (props) => {

    const [preference, setPreference] = useState(false);

    return (
        <div className={"form-checkbox"}>

            <input type="checkbox"
                   disabled={props.disabled}
                   className="form-check-input"
                   id={"alert-preference-checkbox"}
                   onChange={async (event) => {
                       setPreference(event.currentTarget.checked)

                       // console.log('PreferenceInput @ onChange -> props', props);

                       let hide_tips = TB.set({}, props.translationKey, event.currentTarget.checked);
                       // console.log('PreferenceInput @ onChange -> hide_tips', hide_tips);
                       let persistedStorage = await TB.persistStoredPreferences({
                           hide_tips
                       });

                       if(!persistedStorage) {
                           console.warn("Error persisting storage: ", hide_tips)
                       }else {
                           console.info("Persisted Saved Preference: ", hide_tips)
                       }
                   }}
                   checked={preference === true}/>

            <label className="form-check-label" htmlFor={"alert-preference-checkbox"}>
                Don’t show this message again
            </label>
        </div>
    )
}
export default class Alert extends Component
{
    static CLEAR_NOTIFICATION_TIMEOUT = CLEAR_NOTIFICATION_TIMEOUT;

    static TYPES = {
        TOAST: 'toast',
        ALERT: 'alert',
        CONFIRM: 'confirm',
        TIP: 'tip'
    };

    static THEMES = () => {
        return {
            success: TB.config('color.green'),
            danger: TB.config('color.red'),
            warning: TB.config('color.orange'),
            info: TB.config('color.info'),
            default: TB.config('color.gray')
        }
    };

    static ActionButton(title, onClick, btnClass = 'btn-info') {
        return {
            title: title || TB.tryTrans('alerts.default.confirm'),
            onClick: onClick || (() => true),
            btnClass
        }
    }

    createPositiveAction(title, onClick = () => true) {
        return Alert.ActionButton(
            title,
            async() => {
                await onClick();
                return this.onPositiveActionClick(this)
            }
        )
    }
    createNegativeAction(title, onClick = () => true) {
        return Alert.ActionButton(
            title,
            async() => {
                await onClick();
                return this.onNegativeActionClick(this)
            },
            'btn-dark'
        )
    }

    getThemeForType(type) {
        switch (type) {
            default:
            case Alert.TYPES.TOAST:
                return Alert.THEMES().success;
            case Alert.TYPES.ALERT:
                return Alert.THEMES().danger;
            case Alert.TYPES.CONFIRM:
                return Alert.THEMES().success;
            case Alert.TYPES.TIP:
                return Alert.THEMES().warning;
        }
    }
    generateActions(actions = [], {type, positiveTitle, negativeTitle}) {
        let actionActions = [];

        if (actions.length) {
            actions.map(({title, onClick}, index) => {
                if(index === 0) {
                    actionActions.push(
                        this.createPositiveAction(title, onClick)
                    )
                }else actionActions.push(this.createNegativeAction(title, onClick))
            })
        }

        switch (type) {
            case Alert.TYPES.CONFIRM:
            case Alert.TYPES.ALERT:
            case Alert.TYPES.TIP:

                if(!actionActions.length) {
                    actionActions.push(
                        this.createPositiveAction(positiveTitle)
                    );
                }

                if(actionActions.length < 2 && negativeTitle) {
                    actionActions.push(
                        this.createNegativeAction(
                            negativeTitle
                        )
                    );
                }
                break;
        }

        return actionActions;
    }

    constructor(props)
    {
        super(props);


        TB.AlertIsShowing = false;

        this.state = {
            isVisible: false,
            visibleTimeout: null,
            onPositiveAction: () => true,
            onNegativeAction: () => true,
            onCloseAction: () => true,
            handleSavedPreferences: false,
            preferenceHidden: false,
            theme: Alert.THEMES().success,
            type: Alert.TYPES.TOAST
        }
    }

    async setAlert(props) {

        await this.clearAlertsHandler();

        if(!props) {
            return this.closeAlert();
        }

        let state = {
            onPositiveAction: () => true,
            onNegativeAction: () => true,
            onCloseAction: () => true,
            handleSavedPreferences: false,
            preferenceHidden: false
        };

        for (let [key, prop] of Object.entries(props)) {
            if(TB.isDefined(prop)) {
                state[key] = prop;
            }
        }

        state.icon = props.icon;

        if(TB.isDefined(props.translationKey)) {
            state.title = TB.tryTrans(`alerts.${props.translationKey}.title`);
            state.message =  TB.transOrFail(`alerts.${props.translationKey}.message`, props.replace || {});
            state.type = TB.transOrFail(`alerts.${props.translationKey}.type`) || Alert.TYPES.TOAST;
            state.theme = TB.transOrFail(`alerts.${props.translationKey}.theme`);
            state.positiveTitle = TB.transOrFail(`alerts.${props.translationKey}.actions.positive`);
            state.negativeTitle = TB.transOrFail(`alerts.${props.translationKey}.actions.negative`);
            state.preferenceHidden = TB.get(TB.storedPreferences(), `hide_tips.${props.translationKey}`);
        }
        else if (TB.isDefined(props.section)
            && TB.isDefined(props.key))
        {
            state.translationKey = `${props.section}.${props.key}`;
            state.preferenceHidden = TB.get(TB.storedPreferences(), `hide_tips.${state.translationKey}`);
        }else if (props.preferenceKey) {
            state.translationKey = props.preferenceKey;
            state.preferenceHidden = TB.get(TB.storedPreferences(), `hide_tips.${state.translationKey}`);
        }

        // console.log('Alert @ setAlert -> props', props);
        // console.log('Alert @ setAlert -> state', state);

        // Handle default type Toast Notification
        if(!state.type) state.type = Alert.TYPES.TOAST;

        if (state.type === Alert.TYPES.TOAST) {
            // Remove previous message state if Toast
            state.message = undefined;
            state.theme = props.theme || state.theme || 'success';
        }else {
            // Set theme
            state.theme = Alert.THEMES()[props.theme || state.theme] ||  this.getThemeForType(state.type);
        }


        // Check for saved preferences
        if(state.type === Alert.TYPES.TIP) {
            state.handleSavedPreferences = true;
        }

        // Generate action click handlers
        let actions = this.generateActions(props.actions, state);

        await this.promisedState({
            ...state,
            actions
        });

        if(this.shouldShowToUser()) {

            if(!this.shouldToast()) {
                await this.promisedState({isVisible: true});
                TB.AlertIsShowing = true;

            }else {
                let type = TB.keys(Alert.THEMES()).includes(props.theme || state.theme) ? (props.theme || state.theme) : 'default';

                if (type === 'danger') {
                    type = 'error';
                }

                setTimeout(() => {
                    toast(state.title, {
                        closeOnClick: true,
                        pauseOnHover: true,
                        type
                    })
                    Alert.visibleTimeout = setTimeout(() => {
                        this.closeAlert()
                    }, CLEAR_NOTIFICATION_TIMEOUT);
                }, 500)
            }
        }else {
            this.onPositiveActionClick();
        }
    }

    clearAlertsHandler() {
        return clearTimeout( Alert.visibleTimeout);
    }

    iconClass() {
        if(this.shouldToast()) return '';

        if (this.state.icon) {
            return this.state.icon;
        }
        switch (this.state.type) {
            default:
            case Alert.TYPES.ALERT:
                return 'fas fa-exclamation-triangle';
            case Alert.TYPES.CONFIRM:
                return 'fas fa-lightbulb';
            case Alert.TYPES.TIP:
                return 'fas fa-info-circle';
        }
    }

    shouldToast() {
        return this.state.type === Alert.TYPES.TOAST
    }

    shouldTip() {
        return this.state.type === Alert.TYPES.TIP
    }

    shouldShowToUser() {
        return !(this.state.handleSavedPreferences && this.state.preferenceHidden);
    }

    canClickOutSideToClose() {
        return (this.shouldShowToUser() && this.shouldTip()) || this.shouldToast()
    }

    onPositiveActionClick() {
        return this.state.onPositiveAction();
    }

    onNegativeActionClick() {
        return this.state.onNegativeAction();
    }

    async closeAlert() {
        let wasOpen = this.state.isVisible;
        await this.promisedState({isVisible: false});
        if (wasOpen) {
            await TB.wait(400);
        }
        await this.clearAlertsHandler();
        await this.state.onCloseAction();
        TB.AlertIsShowing = false;
    }

    render() {

        let {
            isVisible,
            theme,
            title,
            message,
            actions,
            handleSavedPreferences,
            preferenceHidden,
            translationKey,
        } = this.state;


        return (
            <ReactPortal wrapperId="react-portal-alert-container">
               <span className={'alert-overlay ' + (isVisible && this.shouldShowToUser() ? 'popped' : '')}
                  onClick={async(e) => {

                      if (e.target !== e.currentTarget) return;
                      e.preventDefault();

                      if(this.canClickOutSideToClose()) {
                          await this.closeAlert();
                      }
                  }}>
                <div className="alert-container" style={this.shouldToast() ? {background: theme} : {borderTopColor: theme}}>
                    {title && (
                        <h2 className={this.shouldToast() ? 'alert-notification-title' : ''}>
                            {title}
                        </h2>
                    )}

                    {this.shouldToast() ? (
                        <span onClick={this.closeAlert.bind(this)} className="close clickable">
                            <span>&times;</span>
                        </span>
                    ) : (
                        <span className="alert-icon">
                            <i className={this.iconClass()} style={{color: theme}}/>
                        </span>
                    )}

                    {message && (
                        <div className="content">
                            <span dangerouslySetInnerHTML={{
                                __html: message
                            }}/>

                            {actions.length > 1 && handleSavedPreferences && !preferenceHidden && (
                                <div className="mt-3">
                                    <PreferenceInput translationKey={translationKey}/>
                                </div>
                            )}
                        </div>
                    )}



                    {actions?.length > 0 && (
                        <div className="alert-actions">
                            {actions.map((action, index) => {
                                let btnClass = action.btnClass || 'btn-info';

                                return (
                                    <button
                                        key={`action-${index}`}
                                        className={"btn btn-small " + btnClass}
                                        onClick={async() => {
                                            await action.onClick().catch(console.warn);
                                            await this.closeAlert();
                                        }}>
                                        {action.title}
                                    </button>
                                )}
                            )}

                            {actions.length < 2 && handleSavedPreferences && !preferenceHidden && (
                                <PreferenceInput translationKey={translationKey}/>
                            )}


                        </div>
                    )}
                </div>
        </span>
            </ReactPortal>
        );
    }

}
export {PreferenceInput}